import { HStack } from "components/Stack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React from "react";

const NO_ACTIVITY_TIME = 5 * 1000; // 5 secs

export class LocationType {
  static ADDRESS = "address";
  static CITIES = "(cities)";
}
export const SCHOOL_LOCATION_TYPE = LocationType.ADDRESS;

export const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;

export function getSuccessComponents(
  message: React.ReactNode,
  setToastMessage?: (msg: string | null) => void
) {
  setTimeout(() => {
    const messageElement = document.querySelector(".talaera-success-message");
    if (messageElement && setToastMessage) {
      setToastMessage(null);
    }
  }, 3000);

  return (
    <div className={"talaera-success-message"}>
      <HStack align={"center"}>
        <div className={"iconContainer"}>
          <CheckCircleIcon style={{ color: "var(--status-success-fill)" }} />
        </div>
        <span>{message}</span>
      </HStack>
    </div>
  );
}

export function getLanguageOptionText(
  lang: { native_name: string; english_name: string } | null | undefined
) {
  if (!lang) {
    return "";
  }

  return lang.native_name + " (" + lang.english_name + ")";
}

type CodeItem = { code: string };

export function findLanguageByCode<T extends CodeItem>(langList: T[], code: string) {
  const ret = langList.find(item => item.code === code);
  return ret ?? null;
}

export function generateGUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}

export function copyToClipboard(textNode: Node | null | undefined) {
  if (textNode) {
    const range = document.createRange();
    range.selectNodeContents(textNode);
    const selection = window.getSelection();
    if (!selection) {
      return;
    }
    selection.removeAllRanges();
    selection.addRange(range);
    // Deprecated, and still the only way to copy a selected range: the async
    // Clipboard API writes a string, not what the reader has highlighted.
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    document.execCommand("copy");
  }
}

export function pluralize(
  singular: string,
  plural: string,
  number: number | boolean | null | undefined
) {
  return number === 1 ? singular : plural;
}

export const capitalize = (string: string) =>
  string.slice(0, 1).toUpperCase() + string.slice(1);

// TODO use structeredClone
// A round trip through JSON, so the value that comes back is the one that went in.
export const cloneDeep = <T,>(data: T): T => JSON.parse(JSON.stringify(data)) as T;

export function shouldResetAutoScrollBehaviour(
  lastScrollingTime: number | null | undefined
) {
  return (
    !lastScrollingTime || new Date().getTime() - lastScrollingTime > NO_ACTIVITY_TIME
  );
}
